export default __webpack_public_path__ + "static/media/logo-white@2x.46c42815.png";